import { Select, Table, TableColumnsType } from 'antd';
import { FC, useEffect, useState } from 'react';
import SimpleHeader from '../../../components/layout/SimpleHeader';
import Button from '../../../components/Button';
import { useHistory, useLocation } from 'react-router-dom';
import Pagination from '../../../components/Pagination';
import config from '../../../lib/config';
import QueryString from 'qs';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { RootState } from '../../../store/rootReducer';
import {
  getDetailCode,
  getDetailCodeLabel,
  getReverseYears,
} from '../../../lib/util';
import useAxios from '../../../hooks/useAxios';
import {
  IGetSpeakingList,
  ISpeakingList,
} from '../../../models/newSpeaking.model';
import { getSpeakingList } from '../../../api/newSpeaking.api';
import useAuth from '../../../hooks/useAuth';
import Loader from '../../../components/Loader';
import ErrorResponse from '../../../components/ErrorResponse';
import { getCommonCodeLabel } from '../../../lib/store';
import SelectEduStep from '../../../components/SelectEduStep';

const CbtSpeakingTest: FC = () => {
  const { t, i18n } = useTranslation();
  const { writeAuthYn } = useAuth();
  const history = useHistory();
  const location = useLocation();
  const query = QueryString.parse(location.search, {
    ignoreQueryPrefix: true,
  });
  const { commonCodes } = useSelector((state: RootState) => state.commonCode);
  const TE0010 = getDetailCode(commonCodes, 'TE0010');
  const TE0008 = getDetailCode(commonCodes, 'TE0008');
  const TE0003 = getDetailCode(commonCodes, 'TE0003');
  const SY0005 = getDetailCode(commonCodes, 'SY0005');
  const SY0011 = getDetailCode(commonCodes, 'SY0011');
  const { data: res, isLoading, error, execute } = useAxios<IGetSpeakingList>();

  const [param, setParam] = useState<any>({});
  const [eduStepCode, setEduStepCode] = useState<string>();
  const [rubricType, setRubricType] = useState<string>();
  const [examType, setExamType] = useState<string>();
  const [speakingExamType, setSpeakingExamType] = useState<string>();
  const [year, setYear] = useState<string>();
  const [examName, setExamName] = useState('');
  const [pageNo, setPageNo] = useState(1);

  useEffect(() => {
    const newParam: any = {
      pageNo: 1,
      perPage: config.pageSize,
    };
    if (query.eduStepCode) {
      newParam.eduStepCode = String(query.eduStepCode);
      setEduStepCode(newParam.eduStepCode);
    }
    if (query.rubricType) {
      newParam.rubricType = String(query.rubricType);
      setRubricType(newParam.rubricType);
    }
    if (query.examType) {
      newParam.examType = String(query.examType);
      setExamType(newParam.examType);
    }
    if (query.speakingExamType) {
      newParam.speakingExamType = String(query.speakingExamType);
      setSpeakingExamType(newParam.speakingExamType);
    }
    if (query.year) {
      newParam.year = String(query.year);
      setYear(newParam.year);
    }
    if (query.examName) {
      newParam.examName = String(query.examName);
      setExamName(newParam.examName);
    }
    if (query.page) {
      newParam.pageNo = +query.page;
      setPageNo(newParam.pageNo);
    }

    execute(getSpeakingList(newParam));
    newParam.page = newParam.pageNo;
    delete newParam.pageNo;
    setParam(newParam);
  }, [location]);

  const onSearch = () => {
    const newParam: any = {};

    if (eduStepCode) {
      newParam.eduStepCode = eduStepCode;
    }
    if (rubricType) {
      newParam.rubricType = rubricType;
    }
    if (examType) {
      newParam.examType = examType;
    }
    if (speakingExamType) {
      newParam.speakingExamType = speakingExamType;
    }
    if (year) {
      newParam.year = year;
    }
    if (examName) {
      newParam.examName = examName;
    }

    history.push(`/cbt/speaking-test?${QueryString.stringify(newParam)}`);
  };

  const columns: TableColumnsType<ISpeakingList> = [
    {
      title: t('common.label.1'),
      dataIndex: 'eduStepCode',
      align: 'center',
      render: value => getCommonCodeLabel('PR0006', value, i18n.language),
    },    
    {
      title: t('cbt.speakingTest.3'),
      dataIndex: 'rubricType',
      align: 'center',
      render: value => getCommonCodeLabel('TE0010', value, i18n.language),
    },
    {
      title: t('cbt.speakTest.column1'),
      dataIndex: 'examName',
      align: 'center',
    },
    {
      title: t('cbt.speakingTest.4'),
      dataIndex: 'examType',
      align: 'center',
      render: (value: string) => getDetailCodeLabel(TE0008, value),
    },
    {
      title: t('cbt.speakTest.column3'),
      dataIndex: 'speakingExamType',
      align: 'center',
      render: (value: string) => getDetailCodeLabel(TE0003, value),
    },
    {
      title: t('cbt.speakTest.column4'),
      dataIndex: 'year',
      align: 'center',
      render: (value: string) => getDetailCodeLabel(SY0005, value),
    },
    {
      title: t('cbt.speakTest.column5'),
      dataIndex: 'testSeq',
      align: 'center',
      render: (value: string) => getDetailCodeLabel(SY0011, value),
    },
    {
      title: t('cbt.speakTest.column6'),
      dataIndex: 'useYN',
      align: 'center',
    },
  ];

  return (
    <>
    <div className="common-search">
      <div className="search-area">
        <ul className="search-bx">
          <li>
            <label>{t('common.placeholder.1')}</label>
            <div>
              <SelectEduStep
                eduStepCode={eduStepCode}
                setEduStepCode={setEduStepCode}
                includeAll
                fullWidth
              />
            </div>
          </li>
          <li>
            <label>{t('cbt.speakingTest.3')}</label>
            <div>
              <Select
                placeholder={t('cbt.speakingTest.3')}
                value={rubricType}
                onChange={value => setRubricType(value)}
              >
                <Select.Option key="all" value="">
                  {t('common.text.all')}
                </Select.Option>
                {TE0010?.map((item) => (
                  <Select.Option
                    key={item.detailCode}
                    value={item.detailCode}
                  >
                    {item.korName}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </li>
          <li>
            <label>{t('cbt.speakingTest.4')}</label>
            <div>
              <Select
                placeholder={t('cbt.speakingTest.4')}
                value={examType}
                onChange={value => setExamType(value)}
              >
                <Select.Option key="all" value="">
                  {t('common.text.all')}
                </Select.Option>
                {TE0008?.map((item) => (
                  <Select.Option
                    key={item.detailCode}
                    value={item.detailCode}
                  >
                    {item.korName}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </li>
          <li>
            <label>{t('cbt.speakTest.column3')}</label>
            <div>
              <Select
                placeholder={t('cbt.speakTest.column3')}
                value={speakingExamType}
                onChange={value => setSpeakingExamType(value)}
              >
                <Select.Option key="all" value="">
                  {t('common.text.all')}
                </Select.Option>
                {TE0003?.map((item) => (
                  <Select.Option
                    key={item.detailCode}
                    value={item.detailCode}
                  >
                    {item.korName}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </li>
          <li>
            <label>{t('cbt.speakTest.column4')}</label>
            <div>
              <Select
                placeholder={t('cbt.speakTest.column4')}
                value={year}
                onChange={value => setYear(value)}
              >
                <Select.Option key="all" value="">
                  {t('common.text.all')}
                </Select.Option>
                {getReverseYears(SY0005).map(item => (
                  <Select.Option
                    key={item.detailCode}
                    value={item.detailCode}
                  >
                    {item.korName}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </li>
          <li>
            <label>{t('cbt.speakTest.placeholder1')}</label>
            <input
              type="text"
              className="form-control w-150p"
              placeholder={t('cbt.speakTest.placeholder1')}
              value={examName}
              onChange={e => setExamName(e.target.value)}
              onKeyPress={e => {
                if (e.key === 'Enter') onSearch();
              }}
            />
            <div className="comm-btn__area">
              <Button
                className="btn-basic small black"
                onClick={onSearch}
                text={t('common.button.search')}
              />
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div className="content scrollbar">
      {isLoading && <Loader />}
      <ErrorResponse error={error} />
      <SimpleHeader
        iconFile="icon-cbt-big.svg"
        parentMenu={t('common.menu.cbt')}
        currentMenu={t('cbt.speakingTest.1')}
        onlyTitle={true}
      />
      <div className="col-frame">
        <div className="comm-bx__between">
          <div></div>
          <div className="comm-btn__area">
            <Button
              className="btn-basic pink"
              onClick={() => history.push('/cbt/speaking-test/create')}
              text={t('cbt.speakTest.button1')}
            />
          </div>
        </div>
        <div className='comm-table__area'>
          <Table
            columns={columns}
            dataSource={res?.data}
            pagination={{
              current: pageNo,
              pageSize: config.pageSize,
            }}
            onRow={(record) => {
              return {
                onClick: () => {
                  history.push(`/cbt/speaking-test/${record.speakingExamCode}/edit`);
                },
              };
            }}
            rowClassName="pointer"
          />
        </div>

        <div className="comm-bx__between">
          <div></div>
          <div className="common-paging center">
            <Pagination
              count={res?.total || 0}
              page={pageNo}
              param={param}
              path="/cbt/speaking-test"
            />
          </div>
          <div className="comm-btn__area right">
            <Button
              className="btn-basic pink"
              onClick={() => history.push('/cbt/speaking-test/create')}
              text={t('cbt.speakTest.button1')}
              writeAuthYn={writeAuthYn}
            />
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default CbtSpeakingTest;
